<template>
  <div class="teac_bg">
    <div>
      <header>
        <el-image :src="iconHeader"></el-image>
        <span class="title_font" @click="goBack">{{ titleName }}</span>
      </header>
      <div style="color:rgb(143 143 143);text-indent:44px;margin-bottom:6px;">副主委排名不分先后</div>
      <div class="title_line"></div>
      <body>
        <template v-if="!isInfoPage">
          <div class="video_bg t-h" v-for="(item, index) in infoList" :key="index" @click="getItemInfo(item)">
            <el-image :src="item.etPhoto" class="video_bg_one">
              <div slot="error">
                <el-image :src="defaultImg"> </el-image>
              </div>
            </el-image>
            <div style="text-align:center;font-size:16px;font-weight:bold;margin-bottom:4px;">{{item.etName}}</div>
            <div style="text-align:center;font-size:16px;font-weight:bold;">{{item.etGoodat}}</div>
            <div class="line_two"></div>
          </div>
        </template>
        <template v-else>
          <div style="margin:30px 0;min-height:100px;width:100%;">
            <div style="float:left">
              <el-image :src="itemInfo.etPhoto" style="width:200px;">
                <div slot="error">
                  <el-image :src="defaultImg"> </el-image>
                </div>
              </el-image>
            </div>
            <div style="float:left;width:calc(100% - 300px);margin-left:20px;">
              <div style="font-size:18px;line-height:30px;">{{itemInfo.etName}}</div>
              <div style="font-size:18px;line-height:30px;">{{itemInfo.etGoodat}}</div>
              <div class="ql-editor" v-html="itemInfo.etDesc" style="margin-top:20px;"></div>
            </div>
          </div>
        </template>
      </body>
    </div>
  </div>
</template>

<script>
import { getTeamList } from "@/network/api";

export default {
  data() {
    return {
      titleName: '专家团队',
      defaultImg: require("@/assets/images/defalut_icon.png"),
      iconHeader: require("@/assets/images/pageico_1.png"),
      infoList: [],
      itemInfo: {},
      isInfoPage: false
    };
  },
  mounted() {
    getTeamList().then((res) => {
      console.log(res);
      this.infoList = res;
    })
  },
  methods: {
    getItemInfo(item) {
      // this.isInfoPage = true;
      // this.itemInfo = item;
      // this.titleName = "专家团队 | " + item.etName + " |【返回】";
    },
    goBack() {
      this.isInfoPage = false;
      this.itemInfo = {};
      this.titleName = "专家团队";
    },
  }
};
</script>


<style scoped>
.teac_bg {
  display: flex;
  justify-content: center;
}
header {
  width: 1150px;
  display: flex;
  margin-bottom: 6px;
  align-items: center;
}
body {
  display: flex;
  width: 1150px;
  flex-wrap: wrap;
  margin-top: 12px;
}
.video_bg {
  margin-left: 12px;
  flex-basis: 18%;
  margin-bottom: 12px;
}
.video_bg p {
  text-align: center;
  font-size: 16px;
  color: #353535;
  font-weight: bold;
}
p {
  text-align: left;
  text-indent: 24px;
  font-size: 16px;
  color: #787878;
  line-height: 24px;
}
.title_line {
  padding: 0;
  height: 1px;
  background-color: #b7b7b7;
}
.title_font {
  color: #397b3e;
  font-size: 20px;
  margin-left: 6px;
  cursor: pointer;
}
.line_two {
  border-bottom: 1px dashed #e2e2e2;
  margin-top: 6px;
}
.video_bg_one {
  width: 100%;
}
.t-h:hover {
  color: #397b3e;
  cursor: pointer;
}
.t-h:hover p {
  color: #397b3e;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/TeamExperts.vue